import { Box, Paper, Skeleton, Stack } from "@mui/material";
import type { FC } from "react";

export interface SearchResultsGridLoadingTileProps {
  imageAspectRatio: string;
}

export const SearchResultsGridLoadingTile: FC<
  SearchResultsGridLoadingTileProps
> = ({ imageAspectRatio }) => {
  return (
    <Paper sx={{ height: "100%" }}>
      <Stack height="100%" position="relative">
        <Box width={"100%"} style={{ aspectRatio: imageAspectRatio }}>
          <Skeleton variant="rectangular" height={"100%"} />
        </Box>
        <Stack
          flexGrow={1}
          padding={1.5}
          gap={2}
          justifyContent="space-between"
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
          >
            <Skeleton height={18} width={100} />
            <Skeleton variant="circular" height={25} width={25} />
          </Stack>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Skeleton height={20} width={60} />
            <Skeleton height={20} width={50} />
          </Stack>
        </Stack>
      </Stack>
    </Paper>
  );
};
